// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/search_provider.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/search/search_provider.proto.
 */
export const file_proto_model_search_search_provider = /*@__PURE__*/
  fileDesc("Cihwcm90by9tb2RlbC9zZWFyY2gvc2VhcmNoX3Byb3ZpZGVyLnByb3RvEgZjYXJtZW4iSAoQU2VhcmNoUHJvdmlkZXJJZBIoCghwcm92aWRlchgBIAEoDjIWLmNhcm1lbi5TZWFyY2hQcm92aWRlchIKCgJpZBgCIAEoCSqoAQoOU2VhcmNoUHJvdmlkZXISHwobU0VBUkNIX1BST1ZJREVSX1VOU1BFQ0lGSUVEEAASGgoWU0VBUkNIX1BST1ZJREVSX0dPT0dMRRABEh8KG1NFQVJDSF9QUk9WSURFUl9UUklQQURWSVNPUhACEhsKF1NFQVJDSF9QUk9WSURFUl9CT09LSU5HEAMSGwoXU0VBUkNIX1BST1ZJREVSX0FNQURFVVMQBEIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the message carmen.SearchProviderId.
 * Use `create(SearchProviderIdSchema)` to create a new message.
 */
export const SearchProviderIdSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_provider, 0);

/**
 * Describes the enum carmen.SearchProvider.
 */
export const SearchProviderSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_provider, 0);

/**
 * Provider of search results
 *
 * @generated from enum carmen.SearchProvider
 */
export const SearchProvider = /*@__PURE__*/
  tsEnum(SearchProviderSchema);

